import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from '@sm/wds-react';

import './Submenu/nav-submenu.scss';

export const BottomLink = ({ title, url, alignment }) => {
  return (
    <Button
      size="sm"
      color="link"
      variant="text"
      className={`sm-nav-submenu__button wds-float--${alignment}`}
      href={url}
    >
      {title}
      <Icon>]</Icon>
    </Button>
  );
};

export default BottomLink;

BottomLink.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  alignment: PropTypes.string.isRequired,
};
